
import React from 'react';

interface ConnectionStatusProps {
  connectionStatus: 'loading' | 'connected' | 'disconnected';
}

const ConnectionStatus: React.FC<ConnectionStatusProps> = ({ connectionStatus }) => {
  if (connectionStatus === 'disconnected') {
    return (
      <div className="w-full bg-destructive/10 text-destructive p-3 text-center">
        Could not connect to the database. Please check your network connection and refresh the page.
      </div>
    );
  }
  return null;
};

export default ConnectionStatus;
